/**
 * Veridex Protocol SDK - EVM Chain Module
 */

export { EVMClient } from './EVMClient.js';
export type { EVMClientConfig } from './EVMClient.js';
export { EVMHubClientAdapter } from './EVMHubClientAdapter.js';
